<template>
    <div class="user">

        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="单位">
                    <el-select v-model="company_id" placeholder="请选择" clearable @change="handleCompany">
                        <el-option v-for="(item, index) in company_list" :label="item.name" :value="item.company_id" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleDeptAdd" v-auth="'/education/dept/add'">添加部门</el-button>
                    <el-button type="success" @click="import_true = true" v-auth="'/education/company/deptImport'">批量导入用户</el-button>
                </el-form-item>

            </el-form>
        </div>

        <!--内容-->
        <div class="product-content">

            <el-row :gutter="20">
                <el-col :span="5">
                    <div class="tree-box">
                        <el-tree
                                v-loading="dep_loading"
                                :data="dep_data"
                                node-key="id"
                                empty-text="暂无部门数据"
                                :highlight-current="true"
                                :expand-on-click-node="false"
                                :props="defaultProps"
                                @check="clickNode"
                        >
                                  <span class="custom-tree-node" slot-scope="{ node, data }">
                                       <el-tooltip class="item" effect="dark" :content="node.label" placement="left">
                                             <span class="custom-tree-node-label">{{ node.label }}</span>
                                       </el-tooltip>

                                    <span class="custom-tree-opts">
                                        <el-button type="text" @click="() => handleUserList(data)">人员列表</el-button>
                                       <span v-if="data.dept_id > 0" class="el-dropdown-link">|</span>
<!--                                        <el-button type="text" @click="() => handleShowSendMsg(data)">发布公告</el-button>-->
<!--                                        <span v-if="data.dept_id > 0" class="el-dropdown-link">|</span>-->
                                       <el-dropdown trigger="click" v-if="data.dept_id > 0">
                                          <span class="el-dropdown-link">操作<i class="el-icon-arrow-down el-icon--right"></i></span>
                                          <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-auth="'/education/dept/add'">
                                                <el-button type="text" size="mini" @click="() => handleDeptAdd(data)">添加部门</el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-auth="'/education/dept/edit'" >
                                                 <el-button type="text" size="mini" @click="() => handleDeptEdit(data)">编辑部门</el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-auth="'/education/dept/del'">
                                                 <el-button type="text" size="mini" @click="() => handleDeptDel(data)">删除部门</el-button>
                                            </el-dropdown-item>
                                          </el-dropdown-menu>
                                        </el-dropdown>
                                    </span>
                                  </span>
                        </el-tree>
                    </div>
                </el-col>
                <el-col :span="19">
                    <el-card class="box-card">

                        <div class="common-seach-wrap">
                            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                                <el-row>
                                    <el-form-item label="创建时间">
                                        <div class="block">
                                            <span class="demonstration"></span>
                                            <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="展示全部部门">
                                        <el-select v-model="query.search_dept" placeholder="请选择">
                                            <el-option value="2" label="是" />
                                            <el-option value="1" label="否" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="姓名">
                                        <el-input v-model="query.keyword" placeholder="姓名" />
                                    </el-form-item>
                                </el-row>
                                <el-row>
                                <el-form-item label="身份证号">
                                    <el-input v-model="query.id_number" placeholder="筛选身份证号码" />
                                </el-form-item>
                                <el-form-item label="电话">
                                    <el-input v-model="query.mobile" placeholder="电话" />
                                </el-form-item>
                                 <el-form-item label="父母电话">
                                    <el-input v-model="query.parent_mobile" placeholder="父母电话" />
                                </el-form-item>

                                <el-form-item>
                                    <el-button type="primary" @click="search">查询</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="success" @click="refresh">刷新</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="warning" @click="handleExport">导出</el-button>
                                </el-form-item>
                                </el-row>

                            </el-form>
                        </div>

                        <div class="table-wrap">
                            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                                <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
                                <el-table-column prop="name" label="姓名"></el-table-column>
                                <el-table-column prop="age" label="年龄" width="60"></el-table-column>
                                <el-table-column prop="id_number" label="身份证号" width="150"></el-table-column>
                                <el-table-column v-if="app_type === 2" prop="student_number" label="学号" width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.student_number ? scope.row.student_number : '/' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="app_type === 2" prop="parent_name" label="父母姓名" width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.parent_name ? scope.row.parent_name : '/' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="app_type === 2" prop="class_name" label="班级" width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.class_name ? scope.row.class_name : '/' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="politics" label="政治面貌" width="100">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.politics === 0">群众</div>
                                        <div v-if="scope.row.politics === 1">团员</div>
                                        <div v-if="scope.row.politics === 2">预备党员</div>
                                        <div v-if="scope.row.politics === 3">党员</div>
                                    </template>
                                </el-table-column>
<!--                                <el-table-column prop="nation" label="民族" width="100">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span>{{scope.row.nation ? scope.row.nation : '/' }}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <el-table-column prop="mobile" label="手机号" width="100"></el-table-column>
                                <el-table-column prop="parent_mobile" label="父母手机号" width="100"></el-table-column>
                                <el-table-column prop="user.points" label="剩余积分" width="80" :key="Math.random()">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.user ? scope.row.user.points : '' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="user.points" label="累计积分" width="80" :key="Math.random()">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.user ? scope.row.user.total_points : '' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  v-if="app_type === 2" prop="age" label="学分" width="60">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.study_credit }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="balance" label="余额" width="60">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.user ? scope.row.user.balance : '' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="company" label="单位/学校" width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.company ? scope.row.company.name : '' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dept" label="部门" width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.dept ? scope.row.dept.name : '' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
                                <el-table-column fixed="right" label="操作" width="150">
                                    <template slot-scope="scope">
                                        <el-button @click="handleCourseLog(scope.row)" type="text" size="small" v-auth="'/education/course/courseLog'">学习记录</el-button>
                                        <el-button @click="handleExamLog(scope.row)" type="text" size="small" v-auth="'/education/exam/examLog'">考试记录</el-button>
                                        <el-button @click="handleUserDetail(scope.row)" type="text" size="small" v-auth="'/education/company/userDetail'">详情</el-button>
                                        <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/company/userEdit'">编辑</el-button>
                                        <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/company/userDel'">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!--分页-->
                        <div class="pagination">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    background
                                    :current-page="query.page"
                                    :page-size="query.list_rows"
                                    layout="total, prev, pager, next, jumper"
                                    :total="total"></el-pagination>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

        </div>
        <!--添加编辑-->
        <dept-edit ref="edit" @fetch-data="companyDeptData"></dept-edit>
        <user-edit ref="useredit" @fetch-data="refresh" />
        <user-detail ref="userdetail" />
        <send-msg ref="sendmsg" />

        <el-dialog title="批量导入说明" :visible.sync="import_true" width="30%">
            <div>1、必填项必填, 按手机号匹配导入,已存在的手机号码不会被导入</div>
            <div>2、每次导入数量不超过1000, 超过的自己手动拆分为多个表格依次导入</div>
            <div>3、扩展字段按后台配置的顺序填写,每个字段代表一列</div>
            <div>4、请严格按照模板填写，<el-link type="primary" :underline="false" href="/dept_user_import.xlsx">下载模板</el-link>
            </div>
            <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
                <el-upload class="avatar-uploader" ref="upload" action="string"
                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :auto-upload="true"
                           :before-upload="onBeforeUploadImage" :http-request="UploadImage" :show-file-list="false">
                    <el-button size="small" icon="el-icon-upload" type="primary">上传用户表格</el-button>
                </el-upload>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    deptDel,
    companyList,
    deptListTree,
    companyUserList,
    depImport,
    companyUserDel,
    exportActUser, deptexport
} from '@/api/education';
    import DeptEdit from './dept-edit';
    import UserEdit from './user-edit';
    import UserDetail from './user-detail';
    import SendMsg from "@/views/education/dept/dept/send-msg";

    export default {
        components: {
            DeptEdit,
            UserEdit,
            UserDetail,
            SendMsg
        },
        data() {
            return {
                dep_loading: false,
                /*是否加载完成*/
                loading: false,
                /*列表数据*/
                tableData: [],
                total: 0,
                query: {
                    create_time: '',
                    dept_id: '',
                    keyword: '',
                    mobile:'',
                    parent_mobile:'',
                    search_dept:'',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],
                company_list: [],
                company_id: '',
                dep_data: [],
                defaultProps:{
                    id: 'dept_id',
                    label: 'name'
                },
                import_true: false,
                app_type: 1,

            };
        },
        created() {
            // 单位列表
            this.companyListData()
        },
        methods: {
            handleShowSendMsg(row){
                this.$refs['sendmsg'].showDialog(row)
            },
            handleCourseLog(row){
                this.$router.push({
                    path: '/education/course/index',
                    query: {
                        user_id: row.user_id,
                        type: 'log'
                    }
                });
            },
            handleExamLog(row){
                this.$router.push({
                    path: '/education/exam/index',
                    query: {
                        user_id: row.user_id,
                        type: 'answer'
                    }
                });
            },
            // 选择单位
            handleCompany(val) {
                this.company_id = val
                this.companyDeptData()
                this.getTableList()
            },
            // 单位列表
            companyListData() {
                this.dep_loading = true
                let query = {status: 1, page: 1, list_rows: 10}
                companyList(query).then((result) => {
                    this.dep_loading = false
                    this.company_list = result.data.list
                    // 默认第一个
                    if (result.data.list.length > 0) {
                        this.company_id = result.data.list[0].company_id
                        this.companyDeptData()
                        // 用户
                        this.getTableList()
                    }

                })
            },
            clickNode(data) {
                console.log(data, 'clickNode')
            },

            // 单位架构
            companyDeptData() {
                this.loading = true
                let query = {
                    company_id: this.company_id
                }
                deptListTree(query).then((result) => {
                    this.loading = false
                    // this.dep_data = JSON.parse(JSON.stringify(data))
                    if(result.data.list.length > 0){
                        this.dep_data = result.data.list
                    }else {
                        this.dep_data = []
                    }
                })
            },

            // 用户导出
            handleExport(row){
                this.loading = true
                import('@/utils/excel').then((excel) => {
                    const tHeader = ['ID', '姓名', '年龄', '身份证号', '学号', '父母姓名', '班级', '政治面貌', '民族', '手机号', '当前剩余积分', '累计获取积分', '学分', '余额', '单位/学校', '部门', '创建时间']
                    const filterVal = ['member_id', 'name', 'age', 'id_number', 'student_number', 'parent_name', 'class_name', 'politics_desc', 'nation', 'mobile', 'user_points', 'user_total_points', 'study_credit', 'user_balance', 'company_name', 'dept_name', 'create_time']

                    // 查询数据
                    deptexport(this.query).then((result)=>{
                        this.loading = false
                        const list = result.data.list
                        if(list.length <= 0){
                            this.$message({type: 'error', message: '没有查询到符合条件的用户'});
                            return false;
                        }
                        console.log(result, 'this.query')
                        const d = new Date();
                        const data = this.formatJson(filterVal, list)
                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: 'export:用户列表_' + d.getMonth() + d.getDay() + d.getHours() + d.getMinutes() + d.getSeconds(),
                            autoWidth: this.autoWidth,
                            bookType: this.bookType,
                        })
                    })
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) =>
                    filterVal.map((j) => {
                        return v[j]
                    })
                )
            },

            /*用户列表*/
            getTableList() {
                this.loading = true
                this.query.company_id = this.company_id
                companyUserList(this.query).then((result) => {
                    this.loading = false
                    this.tableData = result.data.list.data
                    this.total = result.data.list.total
                    this.app_type = 2
                })
            },
            handleUserList(data){
                this.query.dept_id = data.dept_id
                this.getTableList()
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },

            handleDeptAdd(row) {
                if(!row || row.dept_id === 0){
                    // 构建数据
                    row = {
                        dept_id: 0,
                        parent_id: 0,
                    }
                }
                row.company_id = this.company_id
                row.parent_id = row.dept_id
                row.scene = 'add'
                this.$refs['edit'].showDialog(row)
            },
            handleDeptEdit(row) {
                row.scene = 'edit'
                row.company_id = this.company_id
                this.$refs['edit'].showDialog(row)
            },
            handleDeptDel(row){
                if (row.dept_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        deptDel({ids: row.dept_id}).then((result) => {
                            this.$message({message: result.msg, type: 'success'});
                            this.companyDeptData()
                        })
                    }).catch(() => {

                    });
                }
            },

            // 添加
            handleAdd(row) {
                // if(!row || row.dept_id === 0){
                //     // 构建数据
                //     row = {
                //         dept_id: 0,
                //         parent_id: 0,
                //     }
                // }
                // row.company_id = this.company_id
                // row.parent_id = row.dept_id
                // row.scene = 'add'
                // this.$refs['edit'].showDialog(row)
            },
            // 编辑
            handleEdit(row) {
                this.$refs['useredit'].showDialog(row)
            },
            handleUserDetail(row) {
                row.company_id = this.company_id
                this.$refs['userdetail'].showDialog(row)
            },
            // 删除
            handleDelete(row) {
                if (row.member_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        companyUserDel({ids: row.member_id}).then((result) => {
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },


            /*选择图片之前*/
            onBeforeUploadImage(file) {
                var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
                const isEXCEL = fileType === 'xlsx';
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isEXCEL) {
                    this.$message.error('上传文件只能是excel格式!');
                }
                if (!isLt10M) {
                    this.$message.error('上传文件大小不能超过 10MB!');
                }
                return isEXCEL && isLt10M;
            },
            /*上传图片*/
            UploadImage(param) {
                let self = this;
                const loading = this.$loading({
                    lock: true,
                    text: '正在处理,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = new FormData();
                formData.append('iFile', param.file);
                formData.append('company_id', this.company_id);
                depImport(formData).then(response => {
                    loading.close();
                    self.import_true = false;
                    self.$message({message: response.msg, type: 'success'});
                    this.refresh()
                }).catch(response => {
                    loading.close();
                    self.$message({message: '本次处理失败', type: 'warning'});
                    param.onError();
                });
            },

        }
    };
</script>

<style scope>
    .tree-box{
        height: 700px;
        overflow-y: scroll;

        /*background: red;*/
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 15px;
        padding-right: 8px;
        position: relative;
    }
    .custom-tree-opts{
        position: absolute;
        right: 0;
        top: -10px;
    }

    .custom-tree-node-label{
        width: 175px;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
        font-size: 12px;
    }
    .el-icon-arrow-down {
        font-size: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/dept/dept/index.vue